export default "__VITE_ASSET__88dedf67__"